<script>
	import { onMount } from "svelte";
	import * as vibes from './vibes.json';


	var player;
	var playerReady = false;
	var curretInterval = null;
	var isStarted = false;
	var isPlaying = false;
	var vibeStatus = null;
	var playlistCount = 0;
	var currentVibeID = null;
	var currentVibe = null;

	let name = 'Vibe Box';
	let myVibes = vibes.vibes;

	const API_END_POINT = 'https://mood.moodrtest.workers.dev/mood/';

	onMount(async () => {
		console.log("Application started");
		console.log(myVibes.length + " vibes loaded"); 

		setTime();

		//Youtube API
		var tag = document.createElement('script');
    	tag.src = "https://www.youtube.com/player_api";
    	var firstScriptTag = document.getElementsByTagName('script')[0];
    	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	});

	window.onYouTubeIframeAPIReady = () => initYTPlayer();


	function initYTPlayer() {
    	//console.log("Youtube API ready");
		// let mobilePlayerDeminsions = {
			
    	player = new YT.Player('ytplayer', {
			height: '100%',
			width: '100%',
			playerVars: {
				'autoplay': 1,
				'mute': 1,
				'cc_load_policy': 1,
				'controls': 2,
				'rel': 0,
				'branding': 0,
				'hl': 'en',
				'origin': 'http://localhost:8080',
				'enablejsapi': 1,
				'widgetid': 1
			},
		});

		player.addEventListener('onReady', function(e) {
			console.log("Player ready");
			playerReady = true;
			//setVibe(myVibes[0]);
		});

		player.addEventListener('onStateChange', function (e) {
			if (e.data == YT.PlayerState.PLAYING) {
				// Get current playlist count
				let playList = player.getPlaylist();
				playlistCount = playList.length;
				//console.log(playlistCount)
				isStarted = true;
				isPlaying = true;
			}

			if (e.data == YT.PlayerState.PAUSED) {
				isPlaying = false;
			}


		});
	}

	function toggleModal(id) {
		var modal = new bootstrap.Modal(document.getElementById(id));
		modal.toggle();
	}

	function setVibe(vibe) {
		// Fetch assets from the API
		if(!playerReady) {
			console.log("Player not ready");
			return;
		}

		vibeStatus = 'loading';


		fetch(API_END_POINT + vibe.shortName + ':' +  vibe.realatedVideoId)
			.then(response => response.json())
			.then(data => {
				let jsonData = data;
				let videoIds = shuffle(jsonData.videos);

				var images = [];
				images = vibe.images;
				images = shuffle(images);
				if( images.length > 5) {
					images = images.slice(0, 5);
				}

				preloadImages(images).then(()=> {
					//Stop current Interval
					if(curretInterval) {
						clearInterval(curretInterval);
						console.log("Interval cleared" + curretInterval);
					}

					player.loadPlaylist(videoIds);
					player.unMute();
					changeBackgroundInterval(images);
					vibeStatus = 'loaded';
					currentVibeID = vibe.id;
					currentVibe = vibe;
				}, 
				(error) => {
					console.log("Error loading images", error);
				});
				
			})
			.catch(error => console.error(error));
	}

	// Function to randomize array elemets 
	function shuffle(array) {
		var currentIndex = array.length, temporaryValue, randomIndex;
		while (0 !== currentIndex) {
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex -= 1;
			temporaryValue = array[currentIndex];
			array[currentIndex] = array[randomIndex];
			array[randomIndex] = temporaryValue;
		}
		return array;
	}

	function preloadImages(images) {
		return new Promise(function(resolve, reject) {
			var promises = [];
			for(var i = 0; i < images.length; i++) {
				promises.push(new Promise(function(resolve, reject) {
					var img = new Image();
					img.onload = () => resolve(images[i]);
            		img.onerror = () => reject(images[i]);

            		img.height = "720px";
            		img.width = "1280px";

					img.src = images[i];
				}));
			}
			Promise.all(promises).then(function() {
				resolve();
			}).catch(function() {
				reject();
			});
		});
	}

	function changeBackgroundInterval(images) {
		changeBackground(images[0]);
		let interval = setInterval(function() {
			let imageUrls = images;
			let randomIndex = Math.floor(Math.random() * imageUrls.length);
			changeBackground(imageUrls[randomIndex]);
			console.log("Background changed");
		}, 300000);
		curretInterval = interval;
	}

	function changeBackground(image) {
		document.body.style.backgroundImage = "url('" + image + "')";
	}

	function setTime() {
		let date = (new Date()).toTimeString().substr(0,5);
		console.log(date);
		document.getElementById("time").innerHTML = date;
		setTimeout(setTime, 1000);
	}
</script>



<section>
	<div class="container">
		<div class="row mt-5">
			<div class="col-md-4">
				
			</div>
		</div>
		<!-- Vibe Holder -->
		<div class="row mt-5">
			<div class="col-md-4">
				<div class="vibe-holder">
					<div class="row mt-3 mb-4">
						<div class="d-flex justify-content-between">
							<h4 class="text-uppercase neon-text">{name}</h4>
							<h4 class="time font-weight-bold"><i class="fa fa-clock-o" aria-hidden="true"></i>&nbsp;<span id="time">00:00</span></h4>
						</div>
					</div>
					<ul class="list-group lg">
						{#each myVibes as vibe}
							<li class="list-group-item lgi d-flex justify-content-between" title="{vibe.description}" on:click="{()=>setVibe(vibe)}">
								<span class="h6 mt-2"><strong>{vibe.name}</strong></span>
								{#if currentVibeID && vibe.id == currentVibeID}
									<i class="fa fa-play-circle text-success mt-2"></i>
								{/if}
							</li>
						{/each}
					</ul>
			
					{#if player && isStarted && vibeStatus == 'loaded'}
					<div class="row mt-4">
						<div class="d-flex justify-content-evenly animate__animated animate__fadeInDown">

							{#if isPlaying}
								<h4><i class="fa fa-pause" aria-hidden="true" on:click="{player.pauseVideo()}"></i></h4>
							{:else}
								<h4><i class="fa fa-play" aria-hidden="true" on:click="{player.playVideo()}"></i></h4>
							{/if}

							<div type="button" class="position-relative" on:click="{()=>toggleModal('ytpIframeModal')}">
								<h4><i class="fa fa-list" aria-hidden="true"></i></h4>
								<span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
								  +{playlistCount - 3}
								  <span class="visually-hidden">playlist videos</span>
								</span>
							</div>
						</div>
					</div>
					{:else}
					<div class="row mt-4">
						<div class="d-flex justify-content-center">
							{ #if vibeStatus == "loading"}
								<h5>Loading...</h5>
							{:else if vibeStatus == "loaded"}
								<h5>{currentVibe.name}</h5>
							{:else}
								<h5>Select a vibe 🙂</h5>
							{/if}
						</div>
					</div>
					{/if}
				</div>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-md-4 text-center">
				<!-- Created by Manthila-->
				<small>Created by <a class="text-white" href="https://www.facebook.com/manthila.mallawa/" target="_blank">Manthila</a></small>
			</div>
		</div>
	</div>
</section>

<!-- YtpIframeModal -->
<div class="modal fade" id="ytpIframeModal" tabindex="-1" aria-labelledby="ytpIframeModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
	  <div class="modal-content">
		<div class="modal-header">
		  <h5 class="modal-title" id="ytpIframeModalLabel">From <span class="text-danger font-weight-bold">YouTube</span></h5>
		  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body text-center" >
			<div class="embed-responsive embed-responsive-16by9">
				<div id="ytplayer" style="min-height:390px;"></div>
			</div>
		</div>
		<!-- <div class="modal-footer">
		  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
		  <button type="button" class="btn btn-primary">Save changes</button>
		</div> -->
	  </div>
	</div>
</div>

<svelte:head>
	<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/js/bootstrap.bundle.min.js" integrity="sha384-A3rJD856KowSb7dwlZdYEkO39Gagi7vIsF0jrRAoQmDKKtQBHUuLZ9AsSv4jD4Xa" crossorigin="anonymous"></script>
</svelte:head>


<style>
	@import url('https://bootswatch.com/5/cyborg/bootstrap.min.css');
	@import url('https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css');
	@import url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');

	::-webkit-scrollbar {
  		width: 10px;
	}

	::-webkit-scrollbar-track {
  		background: #f1f1f1; 
	}

	::-webkit-scrollbar-thumb {
  		background: #888; 
	}

	::-webkit-scrollbar-thumb:hover {
  		background: #555; 
	}

	

	:global(body){
        background-color: lightseagreen;
        background-image: url("./assets/images/background.jpg");
		background-size: cover;
		background-repeat: no-repeat;
		background-attachment: fixed;
		background-position: center;
		transition: background-image 3s;
    }
	.neon-text {
		animation: flicker 3s infinite alternate;
		color: #fff;
	}

	.vibe-holder {
		border-radius: 5px;
		padding: 20px;
		margin-bottom: 20px;
		/* Back drop */
		box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.705);
		background-color: rgba(0,0,0,0.4);
	}

	.lg {
		max-height: 360px;
		overflow-y: scroll;
	}

	.lgi {
		cursor: pointer;
		/* Invisible background */
		background-color: rgba(0,0,0,0.4);
		font-weight: bold;	
	}

	.lgi:hover {
		box-shadow: #f1f1f1 0px 0px 10px;
	}

	@keyframes flicker {
		0%, 18%, 22%, 25%, 53%, 57%, 100% {
			text-shadow:
			0 0 4px rgba(255, 255, 255, 0.767),
			0 0 11px rgba(255, 255, 255, 0.767),
			0 0 19px rgba(255, 255, 255, 0.767),
			0 0 40px rgba(43, 46, 245, 0.651),
			0 0 80px rgba(43, 46, 245, 0.651),
			0 0 90px rgba(43, 46, 245, 0.651),
			0 0 100px rgba(43, 46, 245, 0.651),
			0 0 150px rgba(43, 46, 245, 0.651);
		}
		20%, 24%, 55% {       
			text-shadow: none;
		}
	}
</style>